import { Routes } from '@angular/router';

import { PageRoute as PageNotFoundRoute } from './error/pageNotFound.component';
import { UriMatcher } from 'src/common/helpers/uriMatcher';
import { frontPageResolver } from './frontPage/frontPage.resolver';
import { wholesalePageResolver } from './wholesale/wholesale.resolver';
import { jobsPageResolver } from './jobs/jobsPage.resolver';
import { AppComponent } from './app.component';

const AppRoutes: Routes = [
  {
    path: 'admin',
    loadComponent: () => import('../admin/admin.component').then((m) => m.AdminComponent),
    loadChildren: () => import('../admin/admin.routes').then((m) => m.AdminRoutes),
    data: {
      preload: false,
    },
  },
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./frontPage/frontPage.component').then((m) => m.FrontPageComponent),
        pathMatch: 'full',
        resolve: {
          page: frontPageResolver,
        },
      },

      {
        path: 'Locations-and-Hours',
        loadComponent: () => import('./locations/locations.component').then((m) => m.LocationsPageComponent),
        pathMatch: 'full',
      },
      {
        path: 'Our-Story',
        loadComponent: () => import('./ourStory/ourStory.component').then((m) => m.OurStoryPageComponent),
        pathMatch: 'full',
      },
      {
        path: 'Thank-You',
        loadComponent: () => import('./thankyou/thankyou.component').then((m) => m.ThankYouComponent),
        pathMatch: 'full',
      },
      {
        path: 'Contact-Us',
        loadComponent: () => import('./contact/contact.component').then((m) => m.ContactPageComponent),
        pathMatch: 'full',
      },
      {
        path: 'Contact-Us/Thank-You',
        loadComponent: () => import('./contact/thankYou.component').then((m) => m.ContactThankYouComponent),
        pathMatch: 'full',
        data: {
          title: ['Thank You', 'Contact Us'],
        },
      },
      {
        matcher: UriMatcher,
        loadComponent: () => import('./jobs/jobsPage.component').then((m) => m.JobsPageComponent),
        pathMatch: 'full',
        resolve: {
          page: jobsPageResolver,
        },
        data: {
          path: 'Job-Postings/?:posting',
        },
      },

      {
        path: 'Holiday-Hours',
        loadComponent: () => import('./holidayHours/holidayHours.component').then((m) => m.HolidayHoursPageComponent),
        pathMatch: 'full',
      },

      {
        path: 'Login',
        loadComponent: () =>
          import('./login/loginPageRedirector.component').then((m) => m.LoginPageRedirectorComponent),
        pathMatch: 'full',
      },

      {
        path: 'Wholesale',
        loadComponent: () => import('./wholesale/wholesale.component').then((m) => m.WholesalePageComponent),
        pathMatch: 'full',
        resolve: {
          page: wholesalePageResolver,
        },
      },

      {
        path: 'Frequently-Asked-Questions',
        loadChildren: () => import('./faq/faq.routes').then((m) => m.FaqRoutes),
      },

      {
        path: 'Cart',
        loadChildren: () => import('./cart/cart.routes').then((m) => m.CartRoutes),
      },

      {
        path: 'products',
        loadChildren: () => import('./products/products.routes').then((m) => m.ProductsRoutes),
      },

      {
        path: 'Search',
        loadChildren: () => import('./search/search.routes').then((m) => m.SearchRoutes),
      },

      {
        path: 'Donations',
        loadChildren: () => import('./donations/donations.routes').then((m) => m.DonationsRoutes),
      },

      {
        path: 'Corporate-Logos',
        loadChildren: () => import('./corpLogos/corpLogos.routes').then((m) => m.CorpLogosRoutes),
      },

      {
        path: 'Custom-Labels',
        loadChildren: () => import('./customLabels/customLabels.routes').then((m) => m.CustomLabelsRoutes),
      },

      {
        path: 'Candy-Buffets',
        loadChildren: () => import('./candyBuffets/candyBuffets.routes').then((m) => m.CandyBuffetsRoutes),
      },

      {
        path: 'Chocolate-Fountains',
        loadChildren: () => import('./fountains/fountains.routes').then((m) => m.FountainsRoutes),
      },

      {
        path: 'Fundraising',
        loadChildren: () => import('./fundraising/fundraising.routes').then((m) => m.FundraisingRoutes),
      },

      {
        matcher: UriMatcher,
        data: {
          path: '!(Fundraising|OrderSheet)!:sheetType',
        },
        loadChildren: () => import('./ordersheet/orderSheet.routes').then((m) => m.OrderSheetRoutes),
      },

      {
        path: 'Customer',
        loadChildren: () => import('./customer/customer.routes').then((m) => m.CustomerRoutes),
      },

      PageNotFoundRoute,
    ],
  },
];

export { AppRoutes };
